import { container, title } from "assets/jss/material-kit-react.js";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const topdevPageStyle = {
  container,
  topdev: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)"
    }
  },
  h2Main:{
    fontSize: "20px !important",
    fontWeight: "bold !important"
  },
  sub:{
    fontSize: "13px !important",
    fontWeight: "bold !important",
  },
  cardAction: {
    textAlign: "right",
    direction: "rlt"
  },
  cardMain: {
    textAlign: "left"
  },
  challengeBox: {
    marginTop: "40px",
    marginBottom: "40px"
  },
  extra: {
    display: "block",
    width: "100%",
    height: "100%",
    textAlign: "left"
  },
  media: {
    height: 140,
  },
  description: {
    margin: "1.071rem auto 0",
    textAlign: "justify !important"
  },
  name: {
    marginTop: "-80px"
  },
  ...imagesStyle,
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  cardHeaderTitle: {
    ...title,
    display: "inline-block",
    position: "relative",
    textDecoration: "none"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  listitem: {
    fontSize: "10px"
  },
  center: {
    textAlign: "center"
  },
  box: {
    paddingBottom: "10px",
    paddingBottom: "50px",
    textAlign: "left",
    direction: "ltr"
  },
  refresh: {
    fontSize: "20px",
    position: "relative",
    top: "5px"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  },
  menu: {
    marginTop: "50px",
    marginBottom: "20px",
    textAlign: "left"
  },
  rightBox: {
    textAlign: "Center",
    marginBottom: "10px"
  },
  actionButton: {
    textAlign: "right",
    width: "100%",
    display: "block"
  },
  questionTile: {
    marginBottom: "25px",

  },
  questionText: {
    textAlign: "left",
    marginBottom: "25px",
    marginTop: "25px",

  },
  card: {
    marginBottom: "20px"
  },
  chips: {
    "& > *": {
      marginRight: "5px",
      marginBottom: "5px"
    }
  },
  justify: {
    textAlign: "left",
    direction: "ltr",
    textAlign: "justify"
  },
  image: {
    width: "50%",
  },
  center: {
    textAlign: "center"
  },
  rightToLeft: {
    textAlign: "left",
    direction: "ltr"
  },
  successButton: {
    color: "green",
  },
  pre:{
    font: "revert !important",
    margin:"0", 
    padding:"0"
  },
  showCode:{
    backgroundColor:"#f9f9f9",
    padding:"0px 20px 20px 20px", 
    borderRadius: "5px",
    borderRight: "3px solid #2DB84B", 
    direction: "ltr",
    textAlign:"left"
  },
  partnerSection: {
    // values are flipped by jss-rtl (same convention as `box` / `rightToLeft`)
    direction: "ltr",
    textAlign: "left",
    width: "100%",
    paddingTop: "8px",
    paddingBottom: "24px",
  },
  challengeCol: {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    paddingBottom: "24px !important",
  },
  challengeActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    padding: "8px 16px 18px !important",
  },
  challengeStartBtn: {
    fontSize: "16px !important",
    fontWeight: "700 !important",
    padding: "12px 20px !important",
    borderRadius: "6px !important",
    backgroundColor: "#1e88e5 !important",
    color: "#fff !important",
    boxShadow: "0 4px 14px rgba(30, 136, 229, 0.45) !important",
    "&:hover": {
      backgroundColor: "#1565c0 !important",
      boxShadow: "0 6px 18px rgba(30, 136, 229, 0.55) !important",
    },
  },
  challengeStartHint: {
    margin: "10px 0 0",
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#1e88e5",
    textAlign: "center",
    fontWeight: 600,
  },
  partnerAside: {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    paddingBottom: "24px !important",
    display: "flex",
  },
  partnerAsideInner: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    direction: "ltr",
    padding: "20px 16px",
    border: "1px solid #eeeeee",
    borderRadius: "8px",
    background: "#fafafa",
    minHeight: "100%",
    boxSizing: "border-box",
  },
  partnerLogo: {
    maxWidth: "88px",
    width: "100%",
    margin: "0 auto 12px",
    display: "block",
    "& img": {
      width: "100%",
      margin: 0,
      transform: "none",
    },
  },
  partnerDescription: {
    direction: "ltr",
    textAlign: "justify",
    color: "#999",
    lineHeight: 1.9,
    margin: "0 auto 16px",
    maxWidth: "640px",
    paddingLeft: "4px",
    paddingRight: "4px",
    "& p": {
      margin: 0,
    },
  },
  partnerBlockTitle: {
    ...title,
    fontSize: "18px !important",
    fontWeight: "bold !important",
    marginTop: "32px",
    marginBottom: "6px",
    paddingLeft: "12px",
    paddingRight: "12px",
    textAlign: "center",
  },
  partnerBlockSub: {
    color: "#999",
    textAlign: "center",
    marginTop: 0,
    marginBottom: "20px",
    paddingLeft: "12px",
    paddingRight: "12px",
    fontSize: "14px",
  },
  partnerInfoWrap: {
    marginTop: "8px",
    marginBottom: "8px",
  },
  partnerInfoItem: {
    paddingLeft: "16px !important",
    paddingRight: "16px !important",
    paddingBottom: "20px !important",
  },
  partnerSolutionItem: {
    paddingLeft: "12px !important",
    paddingRight: "12px !important",
    paddingBottom: "28px !important",
  },
  partnerSolutionLink: {
    color: "#555",
    textDecoration: "none !important",
    display: "block",
    height: "100%",
    "&:hover": {
      color: "#1e88e5",
    },
    "& h5": {
      marginTop: "14px",
      marginBottom: "8px",
      fontSize: "15px",
      fontWeight: 600,
      color: "#3C4858",
    },
    "& p": {
      margin: 0,
      fontSize: "13px",
      color: "#999",
      lineHeight: 1.7,
    },
  },
  partnerSolutionImg: {
    width: "100%",
    height: "140px",
    objectFit: "cover",
    borderRadius: "6px",
    boxShadow: "0 5px 15px -8px rgba(0,0,0,.4)",
    margin: "0 !important",
    transform: "none !important",
  },
  partnerSolutionImgDark: {
    width: "100%",
    height: "140px",
    objectFit: "contain",
    objectPosition: "center",
    borderRadius: "6px",
    background: "linear-gradient(160deg, #0b1220 0%, #152238 100%)",
    boxShadow: "0 5px 15px -8px rgba(0,0,0,.4)",
    margin: "0 !important",
    transform: "none !important",
  },
  partnerHonorItem: {
    paddingLeft: "10px !important",
    paddingRight: "10px !important",
    paddingBottom: "20px !important",
  },
  partnerHonorCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: "170px",
    height: "100%",
    padding: "20px 14px",
    marginBottom: 0,
    background: "#fff",
    border: "1px solid #eeeeee",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,.06)",
    textDecoration: "none !important",
    color: "inherit",
    cursor: "default",
    pointerEvents: "none",
  },
  partnerHonorImg: {
    height: "56px",
    width: "auto",
    maxWidth: "90%",
    objectFit: "contain",
    margin: "0 0 14px 0 !important",
    transform: "none !important",
  },
  partnerHonorTitle: {
    margin: 0,
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#3C4858",
    fontWeight: 500,
  },
  partnerActions: {
    marginTop: "4px",
    marginBottom: 0,
    textAlign: "center",
  },
};

export default topdevPageStyle;
